import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import { useAppSelector, useAppDispatch } from '../../redux/hooks'
import { closeMobileSidebar } from '../../redux/reducers/settingsSlice'

const AppLayout: React.FC = () => {
  const dispatch = useAppDispatch()
  const { sidebarCollapsed, sidebarOpenMobile } = useAppSelector((state) => state.settings)
  
  return (
    <div className="flex h-screen bg-background">
      {/* Mobile Backdrop */}
      {sidebarOpenMobile && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => dispatch(closeMobileSidebar())}
          aria-hidden="true"
        />
      )}
      
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content - No margin on mobile, sidebar overlays */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${
        sidebarCollapsed ? 'md:ml-16' : 'md:ml-64'
      }`}>
        {/* Header */}
        <Header />
        
        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-muted/10 p-3 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default AppLayout